module.exports = require('./helpers/bundle-url').getBundleURL('id8OZ') + "logo.c51670a8.svg";